import { render } from "./ChevronDoubleRightIcon.vue?vue&type=template&id=ebfcf070"
import script from "./ChevronDoubleRightIcon.vue?vue&type=script&lang=js"
export * from "./ChevronDoubleRightIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__